// © 2025 Camp Promethean, LLC. All Rights Reserved.

import { cn } from "@/lib/utils";

interface MarketingAmbientBgProps {
  className?: string;
  /** Stronger glow for hero / auth pages */
  intensity?: "default" | "hero";
}

export function MarketingAmbientBg({
  className,
  intensity = "default",
}: MarketingAmbientBgProps) {
  return (
    <div
      aria-hidden="true"
      className={cn("marketing-ambient pointer-events-none", className)}
    >
      <div
        className={cn(
          "marketing-ambient__orb marketing-ambient__orb--ember marketing-ambient__orb--animate-1",
          intensity === "hero" && "marketing-ambient__orb--hero",
        )}
      />
      <div className="marketing-ambient__orb marketing-ambient__orb--gold marketing-ambient__orb--animate-2" />
      <div className="marketing-ambient__orb marketing-ambient__orb--depth marketing-ambient__orb--animate-3" />
      <div className="marketing-ambient__mesh" />
    </div>
  );
}

export default MarketingAmbientBg;
